import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-brand-violet text-white",
        secondary: "border-transparent bg-brand-cyan text-brand-midnight",
        outline: "border-border text-foreground",
        muted: "border-transparent bg-muted text-muted-foreground",
        ok: "border-transparent bg-signal-ok/15 text-signal-ok",
        running: "border-transparent bg-signal-running/15 text-signal-running",
        awaiting: "border-transparent bg-signal-awaiting/15 text-signal-awaiting",
        failed: "border-transparent bg-signal-failed/15 text-signal-failed",
        paused: "border-transparent bg-signal-paused/15 text-signal-paused",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
